<template>
  <img
    v-if="src"
    :src="src"
    :style="imageStyle"
    class="fav-icon-image"
    alt=""
    aria-hidden="true"
    loading="lazy"
    draggable="false"
  />
</template>

<script setup>
import { computed } from 'vue'
import { googleFaviconUrl } from '../services/favicons.ts'

const props = defineProps({
  domain: {
    type: String,
    default: '',
  },
  size: {
    type: Number,
    default: null,
  },
  // The size to ask the service for, when it differs from the size drawn.
  fetchSize: {
    type: Number,
    default: null,
  },
})

const resolvedSize = computed(() => props.size || 32)
const src = computed(() => googleFaviconUrl(props.domain, { size: props.fetchSize || resolvedSize.value }))
const imageStyle = computed(() => {
  if (props.size === null || props.size === undefined) return null
  return { width: `${props.size}px`, height: `${props.size}px` }
})
</script>

<style scoped>
.fav-icon-image {
  object-fit: contain;
  flex-shrink: 0;
}
</style>
